const certificateDownload = {
    "enableCertificatePhoto": true,
    "certificateData": [
        {
            "code": "TAF-QM110049",
            "name": "實驗室認證規範ISO/IEC 17025訓練",
            "classDate": "2021/10/12~2021/10/14",
            "location": "線上",
            "participationCertificate": {},
            "participationCertificateDownload": true,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": true
        },
        {
            "code": "TAF-MH110002",
            "name": "醫學實驗室主管訓練",
            "classDate": "2021/10/20~2021/10/22",
            "location": "線上",
            "participationCertificate": {},
            "participationCertificateDownload": false,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": true
        },
        {
            "code": "TAF-IB110006",
            "name": "檢驗機構認證規範ISO/IEC 17020與ILAC-P15訓練",
            "classDate": "2021/10/28~2021/10/29",
            "location": "線上",
            "participationCertificate": {},
            "participationCertificateDownload": true,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": false
        },
        {
            "code": "TAF-QP110004",
            "name": "產品驗證機構認證規範ISO/IEC 17065訓練",
            "classDate": "2021/12/21~2021/12/22",
            "location": "台北",
            "participationCertificate": {},
            "participationCertificateDownload": false,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": false
        }
    ]
};

export default certificateDownload;